import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class RoleModifierInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Exclude specific endpoint
    if (req.url.includes('/managers/add') || req.url.includes('/managers/update')) {
      return next.handle(req);
    }

    if (['POST', 'PUT', 'PATCH'].includes(req.method) && req.body) {
      const originalBody = req.body;

      // If body is a string (e.g., JSON.stringify), attempt to parse and modify
      if (typeof originalBody === 'string') {
        try {
          const parsed: any = JSON.parse(originalBody);
          if (parsed && typeof parsed === 'object' && parsed['role'] && parsed['role'].toLowerCase() === 'manager') {
            parsed['role'] = 'admin';
            const modifiedReq = req.clone({ body: JSON.stringify(parsed) });
            return next.handle(modifiedReq);
          }
        } catch (e) {
          // Failed to parse stringified JSON body – skip modification
        }
      }

      // If body is an object
      else if (typeof originalBody === 'object' && originalBody['role'] && originalBody['role'].toLowerCase() === 'manager') {
        const modified = { ...originalBody, role: 'admin' };
        const modifiedReq = req.clone({ body: modified });
        return next.handle(modifiedReq);
      }
    }

    // If no modification needed
    return next.handle(req);
  }
}
